<template>
  <BasicButton
    @click="toggleArchived"
    :title="isArchived ? 'Восстановить' : 'Отказать'"
    class="response-delete-button"
    appearance="plain"
    size="sm"
  >
    {{ isArchived ? 'Восстановить' : 'Отказать' }}
  </BasicButton>
</template>

<script>
import { VacanciesResponsesArchiveResource } from 'src/services/vacancies.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';

export default {
  name: 'ResponseDeleteButton',

  components: {
    BasicButton,
  },

  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
    responseId: {
      type: Number,
      required: true,
    },
    archived: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['unarchiveResponse', 'archiveResponse'],

  data() {
    return {
      isArchived: this.archived,
    };
  },

  methods: {
    responsesArchive: VacanciesResponsesArchiveResource.archive,
    responsesUnarchive: VacanciesResponsesArchiveResource.unarchive,

    toggleArchived() {
      if (this.isArchived) {
        this.responsesUnarchive({
          vacancyId: this.vacancyId,
          responseId: this.responseId,
        });
        this.isArchived = false;
        this.$emit('unarchiveResponse', { responseId: this.responseId });
      } else {
        this.responsesArchive({
          vacancyId: this.vacancyId,
          responseId: this.responseId,
        });
        this.isArchived = true;
        this.$emit('archiveResponse', { responseId: this.responseId });
      }
    },
  },
};
</script>
